import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import booksService from '../../services/booksService';
import {BookStateType} from '../../types/types';
interface searchBooks {
  keyword: string;
}

interface getBookById {
  id: string;
}

export const getBookById = createAsyncThunk(
  'book/getBookById',
  async ({id}: getBookById) => {
    const response = await booksService.getBookById(id);
    return response;
  },
);

export const searchBooks = createAsyncThunk(
  'book/searchBooks',
  async ({keyword}: searchBooks) => {
    const response = await booksService.searchBooks(keyword, 0, 20);
    return response;
  },
);

const initialState: BookStateType = {
  show: false,
  loading: false,
  data: [],
  error: null,
  current: null,
};

const bookSlice = createSlice({
  name: 'book',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(searchBooks.fulfilled, (state, action) => {
      state.show = true;
      state.loading = false;
      state.data = action.payload.content;
    });
    builder.addCase(searchBooks.rejected, (state, action) => {
      state.show = true;
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(searchBooks.pending, (state, action) => {
      state.show = false;
      state.loading = true;
      state.error = null;
      state.data = [];
    });
    builder.addCase(getBookById.fulfilled, (state, action) => {
      state.show = true;
      state.loading = false;
      state.current = action.payload; // action.payload.content
    });
    builder.addCase(getBookById.rejected, (state, action) => {
      state.show = true;
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getBookById.pending, (state, action) => {
      state.show = false;
      state.loading = true;
      state.error = null;
      state.current = null;
    });
  },
});

export default bookSlice.reducer;
